// http://vanslaars.io/post/motorcycle-declarative-form-input/
// http://vanslaars.io/post/motorcycle-lessons-follow-up/

import {div, label, input, hr, h4, button, p} from '@motorcycle/dom';

import isolate from '@cycle/isolate'

import most from 'most'

import Submit from './submit_enter_naked'

function view(state$,compvtree$){
  return most.combine((state,compvtree)=>{
    return div([
      compvtree,
      h4('Hello, '+state)
    ]);
  },state$,compvtree$);
}

export default isolate(sources=>{
  const comp = Submit(sources)

  const state$ = comp.submit$.startWith('John')

  const vtree$ = view(state$, comp.DOM)

  return {
    DOM: vtree$
  }
});


/** WEBPACK FOOTER **
 ** ./components/nameshower.js
 **/